<template>
  <v-menu
    ref="datePicker"
    :close-on-content-click="false"
    v-model="picker"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px">
    <v-text-field
      slot="activator"
      :value="value | dashToDotsDateFormat"
      :label="label"
      :rules="rules"
      :error-messages="errorMessages"
      readonly/>
    <v-date-picker
      :locale="locale"
      :value="value"
      :allowed-dates="allowedDates"
      type="month"
      no-title
      @input="save"
    />
  </v-menu>
</template>

<script>
import { dashToDotsDateFormat } from '@/utils/customFormatters'

export default {
  name: 'MonthPicker',
  filters: {
    dashToDotsDateFormat
  },
  props: [
    'value',
    'label',
    'errorMessages',
    'rules',
    'allowedDates'

  ],
  data () {
    return {
      date: null,
      picker: false
    }
  },
  computed: {
    locale () {
      return `${localStorage.locale}-${localStorage.locale}`
    }
  },
  methods: {
    save (value) {
      this.$emit('input', value)
      this.picker = false
    }
  }
}
</script>

<style scoped>

</style>
